import { getProductQuantityInOrders, getShippedQuantityInOrders } from "../utils/stockCalculations";

/**
 * Het voorraadbeeld bij een regel in stap 2 van de aanmaakwizard: alles wat je
 * wilt weten voordat je een aantal invult, op één plek.
 *
 *   voorraad + onderweg + in bestelling + deze order  ⟷  verkocht in de periode
 *
 * Links staat wat er straks is, rechts wat er in een vergelijkbare periode de
 * deur uit ging. Meer conclusie trekt dit bewust niet: geen "advies-aantal" of
 * dekking in weken. Daarvoor zou je seizoen, levertijd en minimale afname
 * moeten kennen, en een getal dat dat niet doet is een verzonnen getal op een
 * scherm waarop je beslist.
 *
 * Dezelfde helpers als de kolommen in stap 1, zodat een product in beide
 * stappen hetzelfde laat zien:
 * - `onderweg` = verzendregels van verzendingen die niet geannuleerd of
 *   afgerond zijn;
 * - `in bestelling` = het nog niet verzonden deel van orders die niet afgerond
 *   of geannuleerd zijn. De order die je nu bewerkt telt niet mee; die staat
 *   apart als `deze order`, met het aantal dat je op dit moment invult.
 */
export const getLineStockPicture = ({ product, purchaseOrders, shipments, editingOrder, soldQuantity, amount }) => {
  const stock = Number(product?.stock) || 0;
  const inTransit = getShippedQuantityInOrders(shipments, product?.id);
  const onOrder = getProductQuantityInOrders(purchaseOrders, shipments, product?.id, editingOrder);
  const thisOrder = Math.max(0, Number(amount) || 0);
  const sold = Math.max(0, Number(soldQuantity) || 0);

  // Negatieve voorraad (verkocht vóór binnenkomst) telt in het totaal wél mee:
  // die stuks zijn al weg zodra de levering binnenkomt. In de balk kan een
  // negatief stuk niet, dus daar is hij nul.
  const expected = stock + inTransit.total + onOrder.total + thisOrder;

  const parts = [
    { key: "stock", value: Math.max(0, stock) },
    { key: "inTransit", value: inTransit.total },
    { key: "onOrder", value: onOrder.total },
    { key: "thisOrder", value: thisOrder },
  ];
  const scale = Math.max(
    parts.reduce((sum, part) => sum + part.value, 0),
    sold,
  );
  const percent = (value) => (scale ? (value / scale) * 100 : 0);

  return {
    stock,
    inTransit,
    onOrder,
    thisOrder,
    sold,
    expected,
    segments: parts.filter((part) => part.value > 0).map((part) => ({ ...part, width: percent(part.value) })),
    soldAt: sold > 0 ? percent(sold) : null,
  };
};
